import { Values } from '@app-evolution-cms/element-ui';

export const HTTP_METHOD = {
  post: 'post',
  put: 'put',
  get: 'get',
  delete: 'delete',
  patch: 'patch',
} as const;

export type HttpMethod = Values<typeof HTTP_METHOD>;
